import {
  BrowsePageSpotlightSkeleton,
  BrowsePageStreamSkeletons,
} from '@aboutyou/logic-components';
import {
  extraLargeScreensLinaria,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const HomePageSkeleton: React.FC = () => {
  return (
    <Wrapper data-ssr-skeleton="HomePageSkeleton">
      <BrowsePageSpotlightSkeleton />
      <BrowsePageStreamSkeletons />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  ${tabletAndUpLinaria('gap: 64px;')}
  ${extraLargeScreensLinaria('gap: 80px;')}
`;
